import { render, staticRenderFns } from "./Pos_history_import_detail.vue?vue&type=template&id=7073b54d&scoped=true&"
import script from "./Pos_history_import_detail.vue?vue&type=script&lang=js&"
export * from "./Pos_history_import_detail.vue?vue&type=script&lang=js&"
import style0 from "./Pos_history_import_detail.vue?vue&type=style&index=0&id=7073b54d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7073b54d",
  null
  
)

export default component.exports